module.exports = __webpack_public_path__ + "img/star.0ef3392c.svg";